import { render, staticRenderFns } from "./labelsExpress.vue?vue&type=template&id=479eb06c&"
import script from "./labelsExpress.vue?vue&type=script&lang=js&"
export * from "./labelsExpress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports